var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4463 10.1968L11.4462 4.88422C11.4463 4.53857 11.1669 4.2592 10.8213 4.25928C10.4757 4.25928 10.1964 4.53865 10.1964 4.88422L10.1963 10.1969L4.88373 10.1968C4.53808 10.1969 4.25879 10.4762 4.25879 10.8218C4.25871 11.1674 4.53808 11.4468 4.88373 11.4467L10.1963 11.4468L10.1964 16.7594C10.1963 17.1051 10.4757 17.3844 10.8214 17.3844C10.9937 17.3844 11.1502 17.3145 11.2633 17.2014C11.3765 17.0882 11.4463 16.9318 11.4463 16.7594L11.4462 11.4468L16.7589 11.4468C16.9313 11.4468 17.0877 11.377 17.2009 11.2638C17.314 11.1507 17.3839 10.9942 17.3839 10.8219C17.3839 10.4762 17.1046 10.1968 16.7589 10.1969L11.4463 10.1968Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.4edac875ea6671f6804c15106322cc49.svg";
export { ForwardRef as ReactComponent };